import { useMemo } from "react";
import { useSelector } from "react-redux";
import { rulesForInfoStepAlert, procedureIpsIdToGroup } from "../data";

const defaultRule = {
  title: "",
  subTitle: "",
};

export const useInfoStepAlertContent = () => {
  const { patientSurgery } = useSelector(
    (state) => state.patient.patientSurgery
  );

  const { scheduleEvents } = useSelector(
    (state) => state.patient.scheduleEvent
  );

  const { state, track, procedure, patient } = patientSurgery.data ?? {};

  const { id: ipsId } = patient.user.ips ?? {};
  const { id: procedureParentId } = procedure.procedure ?? {};

  return useMemo(() => {
    const groupKey = procedureIpsIdToGroup[`${procedureParentId}-${ipsId}`];
    if (!groupKey) return defaultRule;

    const baseRules = rulesForInfoStepAlert[groupKey];
    if (!baseRules) return defaultRule;

    const trackRules = baseRules[track];
    if (!trackRules) return defaultRule;

    const rule = trackRules[state];
    if (!rule) return defaultRule;

    return {
      title:
        typeof rule.title === "function"
          ? rule.title({ procedure })
          : rule.title ?? "",
      subTitle:
        typeof rule.subTitle === "function"
          ? rule.subTitle({ procedure })
          : rule.subTitle ?? "",
    };
  }, [procedureParentId, ipsId, track, state, procedure, scheduleEvents]);
};
